// extracted by mini-css-extract-plugin
export default {"content":"MobileFullScreen_content__ngfra","fullUp":"MobileFullScreen_fullUp__b0Cgg","body":"MobileFullScreen_body__AhzwX"};